import { ReactComponent as GoogleIcon } from "assets/google-icon.svg";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import {
  googleLogout,
  TokenResponse,
  useGoogleLogin,
} from "@react-oauth/google";
import CommonConstants from "constants/CommonConstants";
import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { createApi } from "util/ApiCreator";
import { AuthController } from "api/auth/AuthController";

export default function GoogleLoginIconButton() {
  const [open, setOpen] = useState<boolean>(false);
  
  const navigate = useNavigate();
  const authAPI = useRef(createApi("auth") as AuthController);

  const googleLogin = useGoogleLogin({
    onSuccess: async (
      codeResponse: Omit<
        TokenResponse,
        "error" | "error_description" | "error_uri"
      >,
    ) => {
      setOpen(true)
      await authAPI.current.loginWithGoogle(codeResponse.access_token);
      setOpen(false);
      googleLogout();
      navigate(CommonConstants.loggedInHomepage);
    },
    onError: (error: any) => console.log("Login Failed:", error),

    // TODO: find a way to fix "Access blocked: process automation has not completed the Google verification process"
    // scope: "openid https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/user.phonenumbers.read",
  });

  return <>
    <Button
      onClick={() => googleLogin()}
      variant="outlined"
      startIcon={<GoogleIcon />}
    >
      Prisijunkite su Google paskyra
    </Button>
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  </>


}
